@let formData = dynamicForm();
@if (formData) {
  <form [formGroup]="formData.formGroup" class="flex flex-col gap-4">
    @for (formModel of formData.formModels; track formModel.key) {
      <div class="drop-shadow-card flex h-fit w-full flex-col rounded-xl bg-white" #formCard>
        @if (showHeader()) {
          @if (headerTemplate) {
            <ng-container [ngTemplateOutlet]="headerTemplate" />
          } @else {
            <div class="border-b-theme-blue-gray flex h-fit w-full flex-row border-b p-4">
              @if (headerIcon()) {
                <img
                  class="mr-2"
                  [ngSrc]="headerIcon()!"
                  width="24"
                  height="24"
                  [alt]="formModel.label" />
              }
              <span class="text-lg font-bold">{{ formModel.label }}</span>
            </div>
          }
        }
        <div class="input-container flex flex-wrap gap-4 p-4">
          @if (formModel.type === 'binary') {
            @let fieldModel = getAsBinaryFormModel(formModel).dependentFieldModel;
            <div class="flex flex-col gap-y-2" [ngClass]="inputWidth()">
              <span class="text-base font-bold">{{ fieldModel!.label.text }}</span>
              <p-checkbox [formControl]="fieldModel!.control!" [binary]="true" />
            </div>
            @let dependentFieldModels =
              fieldModel!.dependents[fieldModel!.value ? 'true' : 'false'];
            @for (dependentFieldModel of dependentFieldModels; track dependentFieldModel.key) {
              <ng-container
                [ngTemplateOutlet]="formFieldFragment"
                [ngTemplateOutletContext]="{ fieldModel: dependentFieldModel }" />
            }
          } @else {
            @for (fieldModel of getAsSimpleFormModel(formModel).fieldModels; track fieldModel.key) {
              <ng-container
                [ngTemplateOutlet]="formFieldFragment"
                [ngTemplateOutletContext]="{ fieldModel }" />
            }
          }
        </div>
      </div>
    }
  </form>
}
<ng-template #formFieldFragment let-fieldModel="fieldModel">
  <div class="flex flex-col gap-y-2" [ngClass]="inputWidth()">
    <div class="text-base font-bold">
      @let appendix = fieldModel.required ? ' (∗)' : '';
      <span
        class="relative"
        [appTooltip]="
          fieldModel.required ? 'Mit Stern (∗) markierte Felder sind erforderlich' : ''
        ">
        {{ fieldModel.label.text }}
        <span class="absolute top-0 text-xs text-neutral-600">{{ appendix }}</span>
      </span>
    </div>
    <shared-ui-dynamic-form-field
      shared-ui-key-info
      [info]="fieldModel.key"
      [fieldModel]="fieldModel"
      [checkboxTemplate]="checkboxTemplate"
      [datepickerTemplate]="dateTemplate"
      [dropdownTemplate]="dropdownTemplate"
      [switchTemplate]="switchTemplate"
      [textinputTemplate]="textinputTemplate"
      [textareaTemplate]="textareaTemplate" />
  </div>
</ng-template>
